import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import { REQUEST, fetchSuccess, fetchFailure } from '../../actions/discovery/profilePreview';
import config from '../../../config';
import { getLocalUser } from '../../../utils/localUser';
import { extractErrorMessage } from '../../../utils/apiResponseHandler';

function* operation({ payload }) {
  try {
    const params = new URLSearchParams({ target_key: payload.target_key });
    if (payload.goal_type) params.set('goal_type', payload.goal_type);
    const response = yield call(
      axios.get,
      `${config.API_URL}/goals/profile-preview?${params.toString()}`,
      { headers: getLocalUser() },
    );
    yield put(fetchSuccess(response?.data?.data));
  } catch (error) {
    // 422 = "not analyzable" with a human message — surface it inline in
    // the wizard rather than through the global error toast.
    yield put(fetchFailure(extractErrorMessage(error)));
  }
}

export function* watch() {
  yield takeLatest(REQUEST, operation);
}
